import React from 'react';
import Box from "@mui/material/Box";
 import Typography from "@mui/material/Typography";
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import TableRow from '@mui/material/TableRow';
import { Affiliate } from '../../../../models';
import { ROUTES } from '../../../../history';


import AppLink from '../../../../components/AppLink';
import { reduceString, titleCase } from '../../../../helpers';
import { blue, } from '@mui/material/colors';
import useHover from '../../../../hooks/useHover';
import RelicAvatar from '../../../../components/RelicAvatar';



const AffiliateListWidget: React.FC<{
    affiliate: Affiliate,
    active?: boolean;
    avatarBgColor?: string;
    onClickCheck?: (p: Affiliate) => void;
}> = ({ affiliate, active = false, avatarBgColor = blue[500], onClickCheck}) => {
    const [hoverRef, isHovered] = useHover<any>();

  return (
    <TableRow ref={hoverRef}>
    <TableCell component="th" scope="row">
        <Box display="flex" alignItems={'center'}>
            <Box display="inline-block" sx={{
                mr: 1
            }}>

                <Checkbox checked={active} onChange={() => {
                    if (onClickCheck) {
                        onClickCheck(affiliate);
                    }
                }} sx={{
                    display: (isHovered || active) ? 'inline-block' : 'none'
                }} />


                <RelicAvatar size={40} display={!(isHovered || active)} user={{
                    FirstName: affiliate.name,
                    LastName: '',
                    CompletedRegistration: true,
                } as any} avatarBgColor={avatarBgColor} />


            </Box>
            <AppLink doNotUseButton to={ROUTES.ADMIN_BASE + "/affiliates/view/" + affiliate.id}>
                <Typography component="span" fontSize="14px" fontWeight={"bold"}>  {reduceString(titleCase(affiliate.name) || "Error", 25)}
                </Typography>
            </AppLink>
        </Box>
    </TableCell>
    <TableCell align="right">
        {affiliate.email}
    </TableCell>
    <TableCell align="right">
        {affiliate.codePrepend}
    </TableCell>
    <TableCell align="right">
        {`${affiliate.split}%`}
    </TableCell>
</TableRow>
  )
}

export default AffiliateListWidget;